export class AdjustmentReasonEntity {
  id?: number
  name?: string | null
}
